.search {
    padding: 0;
    box-sizing: border-box;
}

.list {
    min-height: 120px;
    max-height: min(360px, 50vh);
    overflow: auto;
}
